module.exports = __webpack_public_path__ + "img/BO.9b648731.png";